import { render, staticRenderFns } from "./SiteMenuItem.vue?vue&type=template&id=1671445c"
import script from "./SiteMenuItem.vue?vue&type=script&lang=js"
export * from "./SiteMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SiteMenuItem.vue?vue&type=style&index=0&id=1671445c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports